import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui'
import Vant from 'vant'
import 'font-awesome/css/font-awesome.min.css'
// import 'element-ui/lib/theme-chalk/index.css'
// 引入组件：
// 引入svg-icon图标
import './icons'
// 引入组件css：
import 'vant/lib/index.css'
// 引入rem相关插件
import 'amfe-flexible'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js' // only needed in custom components

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// 注册组件：
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)
// Tell Vue to install the plugin.
Vue.use(VuejsDialog)
// Vue.use(ElementUI)
Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   if (window.Login_Title) {
//     document.title = `${window.Login_Title}`
//   } else {
//     document.title = ``
//   }
//   next()
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (window.Login_Title)
  {
    document.title = `${window.Login_Title}`
  } else
  {
    document.title = ``
  }
  let test_before_post = true
  const beforePost = window.m304 ? window.m304.test_before_post : 1
  if (beforePost == 1)
  {
    test_before_post = true
  } else
  {
    test_before_post = false
  }
  if (from.path === '/seForm' && test_before_post)
  {
    // alert(from.path)
    // Dialog.confirm({
    //   title: '退出',
    //   message: '当前界面未保存，确定退出吗？'
    // })
    //   .then(() => {
    //     setTimeout(() => {
    //       next()
    //     }, 1000)
    //   })
    //   .catch(() => {
    //     setTimeout(() => {
    //       next(false)
    //     }, 1000)
    //   })

    ///// Dialog.confirm 有bug，只能提示1次
    // if (confirm('当前界面未保存，确定退出吗？') == true) {
    //   next()
    // } else {
    //   next(false)
    // }
    Vue.dialog
      .confirm('当前界面未保存，确定退出吗？', {
        okText: '退出',
        cancelText: '取消'
      })
      .then(function (dialog) {
        next()
      })
      .catch(function () {
        next(false)
      })
  } else
  {
    next()
  }
})
